var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":_vm.showDialog}},[_c('v-icon',[_vm._v("mdi-pencil")])],1),(_vm.isDialogVisible)?_c('role-dialog',{attrs:{"showDialog":_vm.isDialogVisible,"role":_vm.role,"loading":_vm.loading},on:{"close":_vm.closeDialog,"submit":_vm.updateRole}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }